import { render, staticRenderFns } from "./disclaimer.vue?vue&type=template&id=cf1510f0&scoped=true"
import script from "./disclaimer.vue?vue&type=script&lang=js"
export * from "./disclaimer.vue?vue&type=script&lang=js"
import style0 from "./disclaimer.vue?vue&type=style&index=0&id=cf1510f0&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cf1510f0",
  null
  
)

export default component.exports